import { FC } from 'react';

import { InputPassword } from './InputPassword';
import { InputPasswordProps } from './interface-form-input';

export const InputNewPassword: FC<InputPasswordProps> = ({
  ...inputProps
}: InputPasswordProps): JSX.Element => {
  return (
    <InputPassword
      translate={'newPassword.title'}
      ariaLabel={'newPasswordInput'}
      name={'newPassword'}
      {...inputProps}
    />
  );
};
